<template lang="pug">
    .nueva-cita.container.wrapper-form.clearfix
        .form-title
            .text-bold
                i.fas.fa-edit.u-black-light
                    | Formulario visita
        .form-wrapper
            .form-group
                label.form-label
                    | Médico
                medic-input(:medic.sync="medic")
            .form-group
                label.form-label
                    | Fecha
                input.form-input(type="date", v-model="date")
            .form-group
                button.btn.btn-primary.float-right(type="button", v-on:click="create")
                    | Pedir
</template>

<script>
import MedicInput from './medic-input'
// import Gun from 'gun'
import gun from '../managers/gun'
// const sea = Gun.SEA
import Swal from 'sweetalert2'
export default {
    components: {
        MedicInput
    },
    data() {
        return {
            medic: "",
            date: new Date()
        }
    },
    methods: {
        async create() {
            // const user = gun.user()
            var citaJSON = {medic: this.medic, date: this.date, patient: gun.user().is.pub}
            // var user = gun.user()
            console.log(this.medic)
            // gun.user(this.medic).get('profile').once(async (profile) => {
                
                Swal.fire("Cita pedida")
                

                gun.get("citas_medicas").set(citaJSON)
                this.$router.push({ name: "citas" })
            // })
 
            // gun.get("citas").get(this.medic)
        }
    },
    created() {

    }
}
</script>